import React, { PureComponent } from 'react'
import moment from 'moment'
import classnames from 'classnames'
import { FormattedMessage, injectIntl } from 'react-intl'
import TimeAgo from 'react-timeago'
import englishStrings from 'react-timeago/lib/language-strings/en'
import frenchStrings from 'react-timeago/lib/language-strings/fr'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import intlMessages from '../../../translations'
import { logError, logMessage, safelyParseJSON } from 'src/utils/helpers'

import chatService from 'src/utils/ChatService'
import EmojiParser from 'src/components/Emoji/Parser'

import styles from '../styles.module.less'

class TextMessageType extends PureComponent {
  constructor(props) {
    super(props)
    const executeMessage = this.isMessageExecutable(props.message)
    this.state = {
      sending: executeMessage,
      retry: false,
      message: props.message,
    }

    // TODO: Check if this should be moved to componentDidMount()
    executeMessage && this.sendMessage(props.message)
  }

  isMessageExecutable = message => {
    if (!message) {
      return false
    }
    // Original message don't have uploaded property
    if (typeof message.execute === 'undefined') {
      return false
    }

    return message.execute || false
  }

  sendMessage = async message => {
    chatService
      .sendMessage(message.body, 'text', this.props.userEmail)
      .then(sendResponse => {
        logMessage('Send response', sendResponse)

        if (sendResponse === false) {
          // If message not actually sent (while offline or some other issue)
          this.setState({
            sending: false,
            retry: true,
          })
        } else {
          this.setState(prevState => {
            return {
              sending: false,
              retry: false,
              message: { ...prevState.message, timestamp: moment.now() },
            }
          })
        }
      })
      .catch(e => {
        logError('Sending text message', e)
        this.setState({
          sending: false,
          // Show retry only if needed (it's not needed while re-trying to send 10 times)
          retry:
            e && e.hasOwnProperty('shouldOfferRetry') && e.shouldOfferRetry === false
              ? false
              : true,
        })
      })
  }

  retrySending = () => {
    const { message, retry } = this.state
    if (!retry) {
      return
    }
    this.setState({
      sending: true,
    })
    this.sendMessage(message)
  }

  render() {
    const { outgoing, intl, renderAuthor } = this.props
    const { sending, message, retry } = this.state

    const formatter =
      intl && intl.locale === 'fr' ? buildFormatter(frenchStrings) : buildFormatter(englishStrings)

    let parsedMessage = safelyParseJSON(message.body)
    if (typeof parsedMessage === 'undefined') {
      parsedMessage = message.body
    }
    if (this.props.botMessageIndex === 0) {
      parsedMessage[0].text = intl.formatMessage(intlMessages.chatBotMessageFirst)
    } else if (this.props.botMessageIndex === 1) {
      parsedMessage[0].text = intl.formatMessage(intlMessages.chatBotMessageSecond)
    }

    return (
      <div
        className={classnames(styles.text, { [styles.cursor]: retry })}
        onClick={this.retrySending}
        data-qa='chat__message__content'
      >
        <div
          data-cy='textMessageType'
          className={classnames(styles.messageItem, { messageItemColor: outgoing })}
          data-qa='chat__message__text'
        >
          <EmojiParser data={message.body} />
        </div>
        <div
          className={styles.status}
          // eslint-disable-next-line react/no-unknown-property
          display-if={sending}
          data-qa='chat__message__status chat__message__status--sending'
        >
          <FormattedMessage id='app.chat.message.sending' defaultMessage='Sending' />
        </div>
        <div
          className={classnames(styles.status, { [styles.errorSending]: true })}
          // eslint-disable-next-line react/no-unknown-property
          display-if={!sending && retry}
          data-qa='chat__message__status chat__message__status--error'
        >
          <FormattedMessage id='app.chat.message.couldNotSend' defaultMessage="Couldn't Send" />
        </div>
        <div
          className={styles.status}
          // eslint-disable-next-line react/no-unknown-property
          display-if={!sending && !retry}
          data-qa='chat__message__status chat__message__status--time'
        >
          {renderAuthor}
          <TimeAgo date={message.timestamp} formatter={formatter} />
        </div>
      </div>
    )
  }
}

export default injectIntl(TextMessageType)
